<div class="cMainContainer">
  <div class="cSimulationCont">
      <router-outlet></router-outlet>
  </div>
  <div id="iBackBtn" (click)="moveToPrevLevel()">Back</div>
  <div id="iNextBtn" (click)="moveToNextLevel()">Next</div>
</div>